<template>
<v-app-bar color="#fff" flat absolute>
  <v-container class="custom-max-width">
    <v-row justify="space-between">
      <v-col cols="6" sm="6" md="3" lg="2" xl="2">
        <v-img height="30" class="ml-0 mr-7" src="/img/logo.svg"></v-img>
      </v-col>
      <v-col cols="6" sm="6" md="3" lg="2" xl="2" class="text-end">
        <v-btn color="#0787DD" variant="outlined" prepend-icon="mdi-phone" rounded class="font-weight-bold text-body-1"><a :href="`tel:${$t('referrers.Header_tel')}`"> {{ $t('referrers.Header_tel') }}</a></v-btn>
      </v-col>
    </v-row>
  </v-container>
</v-app-bar>
</template>

<script>
export default {
  name: "Header",
}
</script>

<style scoped lang="scss">
.custom-max-width {
  @media (min-width: 1280px) {
    max-width: 1200px;
  }
}
</style>
